import { createPortalClient, createPublicClient } from './createPortalClient';
import { getPortalConfig, PORTALS } from './portals';

export const adminApi = createPortalClient({
  portal: PORTALS.ADMIN,
  baseURL: getPortalConfig(PORTALS.ADMIN).getBaseURL(),
});

export const advertiserApi = createPortalClient({
  portal: PORTALS.ADVERTISER,
  baseURL: getPortalConfig(PORTALS.ADVERTISER).getBaseURL(),
});

export const publicApi = createPublicClient({
  baseURL: process.env.PUBLIC_API_URL,
});

// A few public endpoints (influencer email links) live under /public-api/v2.
export const publicApiV2 = createPublicClient({
  baseURL: (process.env.PUBLIC_API_URL || '').replace(
    '/public-api/v1',
    '/public-api/v2'
  ),
});

export function getClientForPortal(portal) {
  return portal === PORTALS.ADVERTISER ? advertiserApi : adminApi;
}
